import React from "react";
import { useAuth } from "../Contexts/useAuth";
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({children}) => {
    const {authed} = useAuth();

    return authed ? children : <Navigate to={"/sign-in"} />
}

export default ProtectedRoute;